/**
 * Admin route guard utility
 * Checks if the current user has admin privileges
 */
import store from '@/store';

/**
 * Check if user has admin role
 * @returns {boolean} True if user is admin
 */
export function isAdmin() {
	const user = store.state.user;
	if (!user || !user.role) {
		return false;
	}
	
	// Check if user has admin role (can be comma-separated roles)
	const roles = user.role.split(',').map(r => r.trim().toLowerCase());
	return roles.includes('admin') || roles.includes('administrator');
}

/**
 * Admin route guard for Vue Router
 * @param {Object} to - Route object for destination
 * @param {Object} from - Route object for current location
 * @param {Function} next - Function to call to continue navigation
 */
export function adminGuard(to, from, next) {
	if (isAdmin()) {
		next();
	} else {
		// Redirect to main app if not admin
		console.warn('Access denied: Admin privileges required');
		next('/chat');
	}
}

/**
 * Check admin status from JWT token directly
 * Useful for server-side validation
 * @param {string} token - JWT token
 * @returns {boolean} True if token contains admin role
 */
export function checkAdminFromToken(token) {
	if (!token) return false;
	
	try {
		// Decode JWT payload (assuming it's a standard JWT)
		const payload = JSON.parse(atob(token.split('.')[1]));
		const roles = payload.roles || '';
		const roleList = roles.split(',').map(r => r.trim().toLowerCase());
		return roleList.includes('admin') || roleList.includes('administrator');
	} catch (error) {
		console.error('Error decoding token:', error);
		return false;
	}
}